import { Icon, Text } from "@blueprintjs/core"
import CustomButton from "components/Atoms/CustomButton"
import CustomCheckbox from "components/Atoms/CustomCheckbox"
import CustomTag from "components/Atoms/CustomTag"
import InfoIcon from "components/Templates/Info"
import dayjs from "dayjs"
import advancedFormat from "dayjs/plugin/advancedFormat"
import React from "react"
import { useSelectedOrder } from "store/dispatch.redux"
import classNames from "utils/classNames"
import { isToday } from "utils/date-utils"
dayjs.extend(advancedFormat)

const Order = ({ order, onClick, onOrderEdit, isSubOrder = false }) => {
  const [isPresent, setSelected] = useSelectedOrder(order)
  const rfd = order?.orderStatus === "RFD"
  const isSelected = order?.isSelected ?? isPresent

  const allItemsSelected = order?.orderItems?.every(
    i => i.isSelected && i?.newQuantity === i?.quantity
  )

  return (
    <div
      className={classNames("vt-order p-3 w-full", {
        "vt-order-resale": order?.orderCategory === "T1",
        "vt-order-old": !isToday(order?.date),
        "vt-order-selected": isSelected,
        "vt-order-rfd": rfd,
      })}
      onClick={isSubOrder ? onClick : setSelected}
    >
      <Icon
        icon={rfd ? "endorsed" : "th-list"}
        intent={rfd ? "success" : "none"}
      />
      <section>
        <p>
          <InfoIcon
            className="mr-1"
            onClick={(e: any) => {
              e.stopPropagation()
              onClick()
            }}
          />
          {order?.user?.fullName} -{" "}
          <span className="vt-muted">
            {dayjs(order?.date).format("Do MMMM YYYY")}
          </span>
          <CustomTag minimal round dark className="ml-2">
            {order.crateCount
              ? `${order.crateCount} Crates`
              : order?.orderItems?.length}{" "}
          </CustomTag>
        </p>
        <Text className="vt-address-text ml-3" ellipsize={true}>
          {order?.shippingAddress?.village ?? "Na"}
        </Text>
        <Text className="vt-address-text ml-3" ellipsize={true}>
          #{order?.trackingCode ?? "Na"}
        </Text>
      </section>
      {!isSubOrder && (
        <>
          <CustomCheckbox
            indeterminate={isSelected && !allItemsSelected ? true : false}
            checked={isSelected && allItemsSelected ? true : false}
            onClick={setSelected}
          />
          <CustomButton
            icon="chevron-right"
            minimal
            onClick={e => {
              if (!isPresent || isSelected === false) {
                ;(setSelected as any)()
              }
              e.stopPropagation()
              onOrderEdit()
            }}
          />
        </>
      )}
    </div>
  )
}

export default Order
